export const verificationKeys = {
  requestCode: ['request-code'],
  validateCode: ['validate-code'],
} as const;
